import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { ReportsManagement } from '../../components/admin/ReportsManagement';

export function ReportsPage() {
  return (
    <AdminLayout
      title="Rapports"
      description="Consultez les rapports financiers et analytiques"
    >
      <ReportsManagement />
    </AdminLayout>
  );
}
